import { ViewMajorV1EventManagePage } from "./ViewMajorV1EventManagePage";

export default ViewMajorV1EventManagePage;
